// =============================================================================
// FILE PATH : src/modules/pms/task_template/components/TaskTemplateFilterBar.js
// MODULE    : PMS → Task Template
// PURPOSE   : Search and filter bar for Task Templates
// =============================================================================

import React, { useState } from "react";
import { TEMPLATE_TYPES } from "../constants/taskTemplateConstants";


const containerStyle = {
  display: "flex",
  gap: "12px",
  alignItems: "center",
  marginBottom: "16px",
  flexWrap: "wrap"
};

const inputStyle = {
  padding: "8px 10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  minWidth: "220px"
};

const selectStyle = {
  padding: "8px 10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  minWidth: "150px"
};

const buttonStyle = {
  padding: "8px 14px",
  borderRadius: "6px",
  border: "none",
  background: "#1976d2",
  color: "#fff",
  cursor: "pointer"
};


const TaskTemplateFilterBar = ({ onApplyFilters }) => {

  const [search, setSearch] = useState("");
  const [type, setType] = useState("");

  // ---------------------------------------------------------------------------
  // APPLY FILTERS
  // ---------------------------------------------------------------------------
  const handleApply = () => {
    onApplyFilters({
      search,
      type
    });
  };

  return (
    <div style={containerStyle}>

      {/* SEARCH */}
      <input
        type="text"
        placeholder="Search template..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={inputStyle}
      />

      {/* TEMPLATE TYPE */}
      <select
        value={type}
        onChange={(e) => setType(e.target.value)}
        style={selectStyle}
      >
        <option value="">All Types</option>
        {TEMPLATE_TYPES.map((t) => (
          <option key={t.value} value={t.value}>
            {t.label}
          </option>
        ))}
      </select>

      {/* APPLY BUTTON */}
      <button onClick={handleApply} style={buttonStyle}>
        Apply
      </button>

    </div>
  );
};

export default TaskTemplateFilterBar;